module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "warning",
      "icon": "ti-cup",
      "title": "Pierwsze uruchomienia aplikacji",
      "value": _vm.statsValue.first,
      "footerText": "test",
      "formatValue": "false",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "success",
      "icon": "ti-wallet",
      "title": "Dodanie nowego podatnika",
      "value": _vm.statsValue.strong,
      "formatValue": "false",
      "footerText": "test",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "danger",
      "icon": "ti-info",
      "title": "Suma wszystkich wypełnionych deklaracji",
      "value": _vm.statsValue.upo_count,
      "formatValue": "false",
      "footerText": "test",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "info",
      "icon": "ti-email",
      "title": "Liczba wysłanych eDeklaracji",
      "value": _vm.statsValue.upo_send_count,
      "footerText": "test",
      "formatValue": "false",
      "footerIcon": "ti-timer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card cardText"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                    Wybierz zakres dla wykresów\n                    "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Pierwsze uruchomienia",
      "url": "api/legacy/first",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "first",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Pierwsze dodanie podatnika",
      "url": "api/legacy/strong",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "strong",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wszystkich wypełnionych deklaracji",
      "url": "api/legacy/wyp",
      "type": "count",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "wyp",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Liczba wysłanych eDeklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "type": "count",
      "dateRange": _vm.dateRange,
      "type_from": "pc_send",
      "localName": "sendCount",
      "amountValue": false
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Podane w naszych statystykach "), _c('strong', [_vm._v("wpłaty 1,5% są kwotami szacunkowymi")]), _vm._v(",\n                    wynikającymi z zastosowania odpowiednich współczynników opartych\n                    na danych statystycznych z poprzednich lat, które\n                    generuje program PIT Format. Brane są pod uwagę kwoty 1,5% wskazane przez podatników w\n                    deklaracjach: "), _c('strong', [_vm._v("zapisanych jako pdf, wydrukowanych oraz wysłanych jako\n                        eDeklaracja")]), _vm._v(".\n\n                    Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny\n                    monitoring wpłat 1,5%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale\n                    nie dostarczono jej finalnie do urzędu skarbowego."), _c('br'), _vm._v("\n                    Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ede59c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Fillings.vue
// module id = 446
// module chunks = 1